import { Navigate } from 'react-router-dom';

const HomepageAdmin = () => {
  return <Navigate to="/admin/pages?page=home" replace />;
};

export default HomepageAdmin;
